import { cn } from '../../../lib/utils';
import { SimpleTooltip } from '../../../components/ui/tooltip';
import { TONE_CLASS, type MetricsCaption } from './creatorMetricsStatus';

const CAPTION_CLASS = 'text-caption-regular inline-flex items-center gap-1';

/** Caption line under a metric value (or in place of it). A `title` — today
 *  the fetch's failure reason — is shown through a tooltip on a focusable
 *  trigger rather than the native attribute: a bare title on a non-focusable
 *  span reaches mouse users only, never keyboard or screen-reader users, and
 *  never fires Radix's focus-triggered open. Same pattern as AvgViewsCell's
 *  value breakdown. */
export function MetricsCaptionText({ caption, title }: { caption: NonNullable<MetricsCaption>; title?: string }) {
  const body = (
    <>
      {caption.spinner && <span aria-hidden className="size-2 animate-pulse rounded-full bg-current" />}
      {caption.label}
    </>
  );

  if (!title) return <span className={cn(CAPTION_CLASS, TONE_CLASS[caption.tone])}>{body}</span>;

  return (
    <SimpleTooltip content={title}>
      <span
        tabIndex={0}
        className={cn(
          CAPTION_CLASS,
          'rounded-sm focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none',
          TONE_CLASS[caption.tone],
        )}
      >
        {body}
      </span>
    </SimpleTooltip>
  );
}
